__turbopack_context__.v({
  "projectCard": "j_t8pG_projectCard",
  "projectCardBadge": "j_t8pG_projectCardBadge",
  "projectCardDescription": "j_t8pG_projectCardDescription",
  "projectCardEmpty": "j_t8pG_projectCardEmpty",
  "projectCardImage": "j_t8pG_projectCardImage",
  "projectCardName": "j_t8pG_projectCardName",
  "projectCardText": "j_t8pG_projectCardText",
});
